import { clsx } from 'clsx';
import { ReactNode } from 'react';

interface Props {
    children: ReactNode;
    className?: string;
}

export const Paragraph = ({ children, className }: Props) => {
    return <p className={clsx('', className)}>{children}</p>;
};
